import React, {useState, useRef, useEffect} from 'react'
import PageControls from '../PageControls/PageControls'
import Timer from 'react-compound-timer'
import Loading from '../loading/Loading'
export default function Session({nextPage, defaultTime, talkingVideo, loopVideo, title, end, handleCancel}) {
    const [looping, setLooping] = useState(false)
    const [checkpoint, setCheckpoint] = useState(0)
    const [addTime, setAddTime] = useState(false)
    const [time, setTime] = useState(defaultTime || 0)
    const [showTimer, setShowTimer] = useState(true)
    const seconds = useRef()
    const onLoad = (e) => {
        console.log(e.duration)
    }
    const endTimer = () => { 
        setAddTime(true)
    }
    const addMoreTime = () => { 
        setAddTime(false)
        setTime(1000 * 60 * 2)
        setShowTimer(false)
        setTimeout(() => {
        setShowTimer(true)
            
        }, 10);
    }
    // console.log(vid)
  
    
    return (
        <div>
            <Loading /> 
 {looping? 
            <video   autoPlay loop src={loopVideo} className="sessionVideo" type="video/mp4" width={'100%'}/>
            :
            <video   autoPlay onEnded={()=> setLooping(true)} src={talkingVideo} className="sessionVideo" type="video/mp4" width={'100%'}/>
            
            }
            
            <div className="sessionContent">

            <PageControls noNext nextPage={nextPage} handleCancel={handleCancel} cancel/> 

<div className="sessionControls">
<div>

    <h1 className="SessionTitle">
        {title}
    </h1>
</div>
    <div >
        {showTimer? 
        
    <Timer initialTime={time}  direction="backward"
        checkpoints={[
       
            {
                time: 0,
                callback: endTimer,
            }
        ]}
    >
   {({getTime}) => (
        <div className="timer">
             Time lapsed: <Timer.Minutes />:{(getTime()/1000 % 60 ) < 10 ? 0:''}<Timer.Seconds ref={seconds} />
         </div>
   )}
        </Timer>
        : ""}
        {addTime? 
        <button onClick={addMoreTime} className="buttonSession">
        Add 2 minutes
        </button>
            : ""}
    </div>
</div>

    <button className="buttonSession next" onClick={()=>nextPage(1)} >{end? "End": "Next"} Section</button>

{looping? 
            <iframe src="https://open.spotify.com/embed/playlist/1Rv9vv4gMNwrKeJcXeLarf"
             width="300" height="80" 
             style={{  position: 'fixed',
                bottom: '70px',
                left: '55px',}}
             frameborder="0" 
             allowtransparency="true"
              allow="encrypted-media"></iframe>
              :''}


            </div>
            
        </div>
    )
}
